import { StrictMode, Suspense } from 'react';
import i18next from 'i18next';
import { createRoot } from 'react-dom/client';
import { initReactI18next } from 'react-i18next';
import './index.css';
import Root from './root';

i18next.use(initReactI18next).init({
  fallbackLng: 'en',
  defaultNS: 'base',
  keySeparator: '>>',
  nsSeparator: '::',
  interpolation: { escapeValue: false },
});

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <Suspense fallback='loading'>
      <Root />
    </Suspense>
  </StrictMode>
);
